export const HOST_MASTER_CONTRACTS_DATA = {
  content: [
    {
      initialContractId: 5077,
      contractMasterStatus: 'REVIEWING',
      deposit: 330000,
      cid: 2185,
      startDate: '2025-08-01',
      endDate: '2025-08-07',
      rid: 1648,
      roomName: '고급단기임대',
      addrLot: '서울특별시 송파구 잠실동 27-4 잠실5치안센터 4층 406호',
      addrStreet: '서울특별시 송파구 잠실로 51-29 4층 406호',
      picMain: 'room/b1f21b72-b70d-48f2-8723-d85dc0effc35.webp',
      guestUid: 1150,
      guestName: '김수영',
      guestPhoneNumber: '99999999999',
      isCallAvailable: false,
      isCheckFinishAvailable: false,
      isDepositDeferAvailable: false,
      isDepositDeferReleaseAvailable: false,
      samsamCareUrl: null,
      contractList: [
        {
          contractId: 5077,
          contractStatus: 'PAY_READY',
          contractStatusDescription: '게스트의 결제를 기다리고 있습니다.',
          week: 1,
          startDate: '2025-08-01',
          endDate: '2025-08-07',
          hostPayTime: null,
          finalPayFee: 1209200,
        },
      ],
    },
    {
      initialContractId: 5061,
      contractMasterStatus: 'ACTIVE',
      deposit: 330000,
      cid: 2179,
      startDate: '2025-07-07',
      endDate: '2025-07-13',
      rid: 1645,
      roomName: '신사 단기방2',
      addrLot: '서울특별시 강남구 신사동 555-30 3층 303호',
      addrStreet: '서울특별시 강남구 도산대로23길 35 3층 303호',
      picMain: 'room/754a0ddd-5268-43c2-8c66-1ebfaf952955.jpg',
      guestUid: 1150,
      guestName: '김수영',
      guestPhoneNumber: '99999999999',
      isCallAvailable: true,
      isCheckFinishAvailable: false,
      isDepositDeferAvailable: false,
      isDepositDeferReleaseAvailable: false,
      samsamCareUrl: null,
      contractList: [
        {
          contractId: 5062,
          contractStatus: 'CANCEL',
          contractStatusDescription: '계약을 승인하지 않아 취소되었습니다.',
          week: 1,
          startDate: '2025-07-14',
          endDate: '2025-07-20',
          hostPayTime: null,
          finalPayFee: 307720,
        },
        {
          contractId: 5076,
          contractStatus: 'APPROVE_READY',
          contractStatusDescription:
            '계약을 승인하시면 게스트가 결제를 진행할 수 있습니다.',
          week: 1,
          startDate: '2025-07-14',
          endDate: '2025-07-20',
          hostPayTime: null,
          finalPayFee: 307720,
        },
        {
          contractId: 5061,
          contractStatus: 'CONTRACT_COMPLETE',
          contractStatusDescription: '정산금이 곧 입금됩니다.',
          week: 1,
          startDate: '2025-07-07',
          endDate: '2025-07-13',
          hostPayTime: null,
          finalPayFee: 615740,
        },
        {
          contractId: 5000,
          contractStatus: 'CONTRACT_COMPLETE',
          contractStatusDescription: '정산금이 곧 입금됩니다.',
          week: 1,
          startDate: '2025-06-30',
          endDate: '2025-07-06',
          hostPayTime: '2025-07-02T15:44:18',
          finalPayFee: 615740,
        },
        {
          contractId: 5001,
          contractStatus: 'CONTRACT_COMPLETE',
          contractStatusDescription: '정산금이 곧 입금됩니다.',
          week: 1,
          startDate: '2025-06-23',
          endDate: '2025-06-29',
          hostPayTime: '2025-07-02T15:44:18',
          finalPayFee: 615740,
        },
      ],
    },
    {
      initialContractId: 4995,
      contractMasterStatus: 'TERMINATING',
      deposit: 330000,
      cid: 2172,
      startDate: '2025-06-18',
      endDate: '2025-06-24',
      rid: 1624,
      roomName: '신사단기방',
      addrLot: '서울특별시 강남구 신사동 555-30 3층 304호',
      addrStreet: '서울특별시 강남구 도산대로23길 35 3층 304호',
      picMain: 'room/754a0ddd-5268-43c2-8c66-1ebfaf952955.jpg',
      guestUid: 1150,
      guestName: '김수영',
      guestPhoneNumber: '99999999999',
      isCallAvailable: false,
      isCheckFinishAvailable: true,
      isDepositDeferAvailable: true,
      isDepositDeferReleaseAvailable: false,
      samsamCareUrl: null,
      contractList: [
        {
          contractId: 5006,
          contractStatus: 'CANCEL',
          contractStatusDescription: '계약을 승인하지 않아 취소되었습니다.',
          week: 1,
          startDate: '2025-06-25',
          endDate: '2025-07-01',
          hostPayTime: null,
          finalPayFee: 201117,
        },
        {
          contractId: 4995,
          contractStatus: 'CONTRACT_COMPLETE',
          contractStatusDescription: '',
          week: 1,
          startDate: '2025-06-18',
          endDate: '2025-06-24',
          hostPayTime: '2025-07-08T15:44:18',
          finalPayFee: 498147,
        },
      ],
    },
    {
      initialContractId: 4996,
      contractMasterStatus: 'TERMINATING',
      deposit: 330000,
      cid: 2172,
      startDate: '2025-06-18',
      endDate: '2025-06-24',
      rid: 1624,
      roomName: '신사단기방',
      addrLot: '서울특별시 강남구 신사동 555-30 3층 304호',
      addrStreet: '서울특별시 강남구 도산대로23길 35 3층 304호',
      picMain: 'room/754a0ddd-5268-43c2-8c66-1ebfaf952955.jpg',
      guestUid: 1150,
      guestName: '김수영',
      guestPhoneNumber: '99999999999',
      isCallAvailable: false,
      isCheckFinishAvailable: false,
      isDepositDeferAvailable: false,
      isDepositDeferReleaseAvailable: true,
      samsamCareUrl: 'https://33m2-sandbox.link/33care',
      contractList: [
        {
          contractId: 4995,
          contractStatus: 'CONTRACT_COMPLETE',
          contractStatusDescription: '',
          week: 1,
          startDate: '2025-06-18',
          endDate: '2025-06-24',
          hostPayTime: '2025-07-08T15:44:18',
          finalPayFee: 498147,
        },
      ],
    },
    {
      initialContractId: 5060,
      contractMasterStatus: 'PAYMENT_CANCELED',
      deposit: 330000,
      cid: 2179,
      startDate: '2025-07-07',
      endDate: '2025-07-13',
      rid: 1645,
      roomName: '신사 단기방2',
      addrLot: '서울특별시 강남구 신사동 555-30 3층 303호',
      addrStreet: '서울특별시 강남구 도산대로23길 35 3층 303호',
      picMain: 'room/9fe0377f-0f5b-4a2b-96b6-0cbd4e96b8ea.png',
      guestUid: 1150,
      guestName: '김수영',
      guestPhoneNumber: '99999999999',
      isCallAvailable: false,
      isCheckFinishAvailable: false,
      isDepositDeferAvailable: false,
      isDepositDeferReleaseAvailable: false,
      samsamCareUrl: null,
      contractList: [
        {
          contractId: 5060,
          contractStatus: 'REFUND',
          contractStatusDescription: '정산금이 곧 입금됩니다.',
          week: 1,
          startDate: '2025-07-07',
          endDate: '2025-07-13',
          hostPayTime: null,
          finalPayFee: 615740,
        },
      ],
    },
    {
      initialContractId: 5010,
      contractMasterStatus: 'CANCELED',
      deposit: 330000,
      cid: 2179,
      startDate: '2025-06-24',
      endDate: '2025-06-30',
      rid: 1645,
      roomName: '신사 단기방2',
      addrLot: '서울특별시 강남구 신사동 555-30 3층 303호',
      addrStreet: '서울특별시 강남구 도산대로23길 35 3층 303호',
      picMain: 'room/160665dd-d04a-4405-8955-902145d57182.gif',
      guestUid: 1150,
      guestName: '김수영',
      guestPhoneNumber: '99999999999',
      isCallAvailable: false,
      isCheckFinishAvailable: false,
      isDepositDeferAvailable: false,
      isDepositDeferReleaseAvailable: false,
      samsamCareUrl: null,
      contractList: [
        {
          contractId: 5010,
          contractStatus: 'CANCEL',
          contractStatusDescription: '게스트가 결제하지 않아 취소되었습니다.',
          week: 1,
          startDate: '2025-06-24',
          endDate: '2025-06-30',
          hostPayTime: null,
          finalPayFee: 615740,
        },
      ],
    },
  ],
  currentPage: 1,
  size: 10,
  totalElements: 6,
  lastPage: 1,
}
